<template>
  <div class="card">
    <div class="card-header">
      <h5 class="card-title mb-0">Nouveau Colis (Stock)</h5>
    </div>
    <form id="form">
      <div class="card-body">
        <div class="row">
          <div class="col-12 mb-2 text-end">
            <button
              type="button"
              class="btn btn-outline-primary"
              @click="importModel"
            >
              <i class="flaticon-cloud-computing me-2"></i>
              <span>Télecharger Un modèle</span>
            </button>
          </div>

          <div class="alert alert-info border-0 rounded-0" role="alert">
            <h6 class="alert-heading fw-bold">
              <i class="bi bi-info-circle me-2"></i>Format d'importation des
              produits
            </h6>
            <p class="mb-0 fs-14">
              Utilisez le format suivant :
              <strong>REF1:QNT1 / REF2:QNT2</strong>
            </p>
            <hr />
            <ul class="mb-0 fs-13">
              <li>Séparez les produits par un slash (<strong>/</strong>).</li>
              <li>
                Séparez la référence et la quantité par deux points
                (<strong>:</strong>).
              </li>
              <li>
                Si la quantité est omise (ex: <strong>REF1</strong>), elle sera
                fixée à <strong>1</strong> par défaut.
              </li>
            </ul>
          </div>

          <div class="col-12">
            <hr />
          </div>
          <div class="col-12 mb-3">
            <input
              type="file"
              class="form-control"
              accept=".xlsx,.xls"
              name="file_import"
              @change="onFileChange"
            />
            <div v-if="import_file && import_file.name" class="mt-2">
              Le fichié Importé: <strong>{{ import_file.name }}</strong>
            </div>
          </div>
          <div class="col-12 mt-3">
            <button
              type="button"
              class="btn btn-outline-success"
              @click="ImportColis"
              :disabled="load || !import_file"
            >
              <span
                v-if="load"
                class="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              <i v-else class="flaticon-cloud-computing me-2"></i>
              <span>{{
                load ? "Importation en cours..." : "Enregistrer les colis"
              }}</span>
            </button>
            <button
              v-if="import_file"
              type="button"
              class="btn btn-outline-danger ms-3"
              @click="RemoveFile"
            >
              <i class="flaticon-delete me-2"></i>
              <span>Supprimer le fichier importé</span>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div v-if="ListColis.length != 0" class="card mt-4 mb-20">
    <div class="card-header">
      <h5 class="card-title mb-0">Nouveaux Colis</h5>
    </div>
    <form @submit.prevent="SaveColis">
      <div class="card-body">
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr class="table-header">
                <th>Code suivi</th>
                <th>Destinataire</th>
                <th>Téléphone</th>
                <th>Adresse</th>
                <th>Prix</th>
                <th>Ville</th>
                <th>Commentaire</th>
                <th>Réf Produits</th>
                <!-- <th class="text-center">
                  <small class="d-block text-muted mb-1">Fragile</small>
                  <select
                    class="form-select form-select-sm shadow-none"
                    v-model="fragile"
                    @change="AllFragile()"
                  >
                    <option :value="1">Oui</option>
                    <option :value="0">Non</option>
                  </select>
                </th> -->
                <th>Type Colis</th>
                <th class="text-center">
                  <small class="d-block text-muted mb-1">Ouvrir</small>
                  <select
                    class="form-select form-select-sm shadow-none"
                    v-model="open"
                    @change="AllOpen()"
                  >
                    <option :value="1">Oui</option>
                    <option :value="0">Non</option>
                  </select>
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(coli, index) in ListColis" :key="index">
                <td>
                  <input
                    type="text"
                    class="form-control"
                    v-model="coli.code_suivi"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    class="form-control"
                    v-model="coli.destinataire"
                    :class="{ 'is-invalid': !coli.destinataire }"
                    required
                  />
                  <div v-if="!coli.destinataire" class="invalid-feedback">
                    Champ requis
                  </div>
                </td>
                <td>
                  <input
                    type="number"
                    class="form-control"
                    v-model="coli.telephone"
                    :class="{
                      'is-invalid':
                        !coli.telephone || coli.telephone.length !== 10,
                    }"
                    required
                    maxlength="10"
                  />
                  <div
                    v-if="!coli.telephone || coli.telephone.length !== 10"
                    class="invalid-feedback"
                  >
                    Téléphone invalide
                  </div>
                </td>
                <td>
                  <input
                    type="text"
                    class="form-control"
                    v-model="coli.adresse"
                    :class="{ 'is-invalid': !coli.adresse }"
                    required
                  />
                  <div v-if="!coli.adresse" class="invalid-feedback">
                    Champ requis
                  </div>
                </td>
                <td>
                  <input
                    type="number"
                    min="0"
                    class="form-control"
                    v-model="coli.prix"
                    :class="{
                      'is-invalid':
                        coli.error_price || !coli.prix || coli.prix < 0,
                    }"
                    required
                  />
                  <div
                    v-if="coli.error_price || !coli.prix || coli.prix < 0"
                    class="invalid-feedback"
                  >
                    Prix invalide
                  </div>
                </td>
                <td>
                  <v-select
                    :id="'city' + index"
                    :style="[
                      coli.error_city ? { border: '1px solid red' } : '',
                    ]"
                    v-model="coli.city"
                    :options="CitiesList"
                    label="ville"
                    @input="GetId(coli, index)"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    class="form-control"
                    v-model="coli.commentaire"
                  />
                </td>
                <td>
                  <template v-if="coli.message">
                    <input
                      type="text"
                      class="form-control is-invalid"
                      v-model="coli.ref_produits"
                      @input="GetIdRef(coli, index, coli.ref_produits)"
                      required
                    />
                    <div class="invalid-feedback text-center">
                      {{ coli.ref }} et/ou qnty est invalide
                    </div>
                  </template>
                  <template v-else-if="coli.refError">
                    <input
                      type="text"
                      class="form-control is-invalid"
                      v-model="coli.ref_produits"
                      @input="GetIdRef(coli, index, coli.ref_produits)"
                      required
                    />
                    <div class="invalid-feedback">
                      Aucun produit avec ce réf :{{ coli.refError }}
                    </div>
                  </template>
                  <template v-else>
                    <input
                      type="text"
                      class="form-control"
                      v-model="coli.ref_produits"
                      @input="GetIdRef(coli, index, coli.ref_produits)"
                      required
                    />
                  </template>
                </td>
                <!-- <td class="text-center">
                  <div class="form-check form-switch d-inline-block">
                    <input
                      class="form-check-input hover-pointer"
                      type="checkbox"
                      v-model="coli.fragile"
                      :true-value="1"
                      :false-value="0"
                    />
                  </div>
                </td> -->

                <td>
                  <select
                    class="form-select form-select-sm"
                    v-model="coli.replace"
                    :class="{ 'text-primary fw-bold': coli.replace != 0 }"
                  >
                    <option :value="0">Simple</option>
                    <option :value="1">Change</option>
                    <!-- <option :value="2">Partial</option> -->
                  </select>
                  <div v-if="coli.replace == 2" class="d-flex gap-1 mt-1">
                    <input
                      type="number"
                      class="form-control form-control-sm px-1 text-center"
                      placeholder="Env"
                      v-model="coli.nbr_sent"
                      title="Nombre envoyé"
                    />
                    <input
                      type="number"
                      class="form-control form-control-sm px-1 text-center"
                      placeholder="Ret"
                      v-model="coli.nbr_rtrn"
                      title="Nombre retourné"
                    />
                  </div>
                </td>

                <td class="text-center">
                  <div class="form-check form-switch d-inline-block">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="coli.open"
                      :true-value="1"
                      :false-value="0"
                    />
                  </div>
                </td>
                <td>
                  <button
                    type="button"
                    class="btn btn-danger btn-sm"
                    title="Supprimer"
                    @click="RemoveRow(coli)"
                  >
                    <i class="flaticon flaticon-delete fs-18"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="load_add" class="mb-3">
          <div class="d-flex justify-content-between mb-1">
            <span class="text-primary fw-bold fs-13"
              >Enregistrement en cours...</span
            >
            <span class="text-primary fw-bold fs-13">{{ progress }}%</span>
          </div>
          <div class="progress" style="height: 10px">
            <div
              class="progress-bar progress-bar-striped progress-bar-animated"
              role="progressbar"
              :style="{ width: progress + '%' }"
              :aria-valuenow="progress"
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
        </div>

        <div class="mt-3 text-end">
          <button
            type="submit"
            class="btn btn-primary"
            :disabled="load_add || ListColis.length === 0"
          >
            <span
              v-if="load_add"
              class="spinner-border spinner-border-sm me-2"
            ></span>
            <span>{{
              load_add ? "Enregistrement..." : "Enregistrer les colis"
            }}</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import api from "@/utils/axios";
import { onMounted } from "vue";
import { defineComponent, ref } from "vue";

export default defineComponent({
  setup() {
    const import_file = ref(null);
    const ListColis = ref([]);
    const CitiesList = ref([]);
    const fragile = ref(0);
    const open = ref(1);
    const replace = ref(0);
    const Inventories = ref([]);
    const { showToast } = useAppToast();
    const userData = ref<any>({});

    const pourcentage = ref(0);
    const load = ref(false);
    const load_add = ref(false);
    const progress = ref(0);
    const fileInputKey = ref(0);
    // Add other refs or reactive objects as needed

    function onFileChange(e) {
      if (e.target.files && e.target.files.length > 0) {
        import_file.value = e.target.files[0]; // ✅ correct
        console.log("File selected:", import_file.value);
      }
    }

    function RemoveFile() {
      import_file.value = null;
      fileInputKey.value += 1; // Reset file input
      console.log("File removed");
      ListColis.value = [];
    }
    async function importModel() {
      try {
        const response = await api.get(`/api/auth/client/ModelImportStock`, {
          responseType: "arraybuffer",
        });
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute("download", "ModeleStockColis.xlsx");
        document.body.appendChild(fileLink);
        fileLink.click();
      } catch (error) {
        console.error("Error downloading import model:", error);
      }
    }

    async function ImportColis() {
      // console.log(import_file.value);
      // console.log(importedFile.value);

      if (!import_file.value) return;

      let formData = new FormData();
      formData.append("import_file", import_file.value); // must be a File object

      load.value = true;
      try {
        const response = await api.post(
          `/api/auth/client/ImportStockColis`,
          formData,
          {
            // ❌ remove this line
            headers: { "content-type": "multipart/form-data" },
          }
        );

        if (response.data.data.length == 0 || response.data.count == 0) {
          showToast("Merci de verifier votre fichier Excel", "error");
        } else {
          ListColis.value = response.data.data;
          for (let j = 0; j < ListColis.value.length; ++j) {
            let txt = "";
            const refParts = ListColis.value[j].ref_produits.split("/");
            for (let i = 0; i < refParts.length; ++i) {
              if (refParts[i].includes(":")) {
                txt = refParts[i].substring(0, refParts[i].indexOf(":"));
              } else {
                txt = refParts[i];
              }
              const ref = Inventories.value.find(
                (el: any) => el.inventory_ref?.trim() === txt.trim()
              );
              console.log(txt, ref);

              if (!ref) {
                ListColis.value[j].refError = txt;
              }
            }
          }
        }
      } catch (error) {
        import_file.value = null;
        fileInputKey.value += 1;
        showToast("Merci de verifier votre fichier Excel", "error");
        console.error("Error importing colis:", error);
      } finally {
        load.value = false;
      }
    }

    function SubstrPhone(val: string) {
      if (val && val !== "" && val !== null) {
        let phone = "";
        if (val.substring(0, 1) === "0" && val.length === 10) {
          phone = val;
          return phone;
        } else if (
          (val.substring(0, 1) === "6" || val.substring(0, 1) === "7") &&
          val.length === 9
        ) {
          phone = "0" + val;
          return phone;
        }
      } else {
        return val;
      }
    }

    function checkPhone(coli: any) {
      if (
        /^(\+212|0)([ \-_/]*)(\d[ \-_/]*){9}$/.test(coli.telephone) === false
      ) {
        coli.phone_error = true;
      } else {
        coli.phone_error = false;
      }
    }

    function GetId(coli: any, index: number) {
      ListColis.value[index].error_city = false;
    }

    async function SaveColis() {
      progress.value = 0;

      if (ListColis.value.some((el: any) => el.exist === false)) {
        showToast("Merci de vérifier les villes des colis", "error");
        return;
      }

      let isValid = true; // Replace with actual validation if needed
      if (!isValid) {
        showToast("Merci de vérifier les informations des colis", "error");
        return;
      }

      let data = new FormData();
      data.append("colis", JSON.stringify(ListColis.value));

      load_add.value = true;

      // Start simulating progress
      const interval = setInterval(() => {
        if (progress.value < 95) {
          // Stop at 95% until API finishes
          progress.value += 5;
        }
      }, 300); // Adjust speed as needed

      try {
        const response = await api.post(
          `/api/auth/client/GetImportStockColis`,
          data
        );

        // API finished → set progress to 100%
        progress.value = 100;

        if (response.data.message === "success") {
          showToast("Colis ajoutés avec succès", "success");
          ListColis.value = response.data.rows || [];
        }
      } catch (error) {
        console.error("Error saving colis:", error);
        showToast("Erreur lors de l'ajout des colis", "error");
      } finally {
        clearInterval(interval); // Stop the simulated progress
        load_add.value = false;
      }
    }

    function RemoveRow(row: any) {
      const index = ListColis.value.indexOf(row);
      if (index > -1) {
        ListColis.value.splice(index, 1);
      }
    }

    function AllFragile() {
      for (let j = 0; j < ListColis.value.length; ++j) {
        ListColis.value[j].fragile = fragile.value;
      }
    }

    function AllOpen() {
      for (let j = 0; j < ListColis.value.length; ++j) {
        ListColis.value[j].open = open.value;
      }
    }

    async function getReplace(coli: any, code: string) {
      coli.existcolis = false;
      let data = new FormData();
      data.append("codesuivi", code);
      try {
        const res = await api.post(`/api/auth/client/ColisExist`, data);
        if (res.data === "not exist") {
          coli.existcolis = true;
        } else if (res.data === "exist") {
          coli.existcolis = false;
        }
      } catch (error) {
        console.error("Error checking colis existence:", error);
      }
    }

    function GetIdRef(coli: any, index: number, refs: string) {
      let txt = "";
      coli.refError = "";
      if (refs.includes("/")) {
        const refParts = refs.split("/");
        for (let i = 0; i < refParts.length; ++i) {
          if (refParts[i].includes(":")) {
            txt = refParts[i].substring(0, refParts[i].indexOf(":"));
          } else {
            txt = refParts[i];
          }
          const ref = Inventories.value.find(
            (el: any) => el.inventory_ref === txt
          );
          if (!ref) {
            coli.refError = txt;
            break;
          }
        }
      } else {
        if (refs.includes(":")) {
          txt = refs.substring(0, refs.indexOf(":"));
        } else {
          txt = refs;
        }
        const ref = Inventories.value.find(
          (el: any) => el.inventory_ref === txt
        );
        if (!ref) {
          coli.refError = txt;
        }
      }
    }

    onMounted(async () => {
      try {
        // Fetch Cities List
        const response = await api.get(`/api/auth/client/SelectCitiesList`);

        CitiesList.value = response.data || [];
        console.log("Cities fetched:", CitiesList.value);
      } catch (error) {
        console.error("Error fetching cities:", error);
      }

      try {
        // Fetch user data
        const response = await api.get(`/api/auth/client/show_customer`);

        userData.value = response.data || [];
      } catch (error) {
        console.error("Error fetching user data:", error);
      }

      try {
        // Fetch Inventories
        const response = await api.get(`/api/auth/client/fecthInventories`);

        Inventories.value = response.data || [];
      } catch (error) {
        console.error("Error fetching inventories:", error);
      }
    });

    return {
      import_file,
      ListColis,
      CitiesList,
      fragile,
      open,
      replace,
      Inventories,
      userData,
      fileInputKey,
      load,
      onFileChange,
      RemoveFile,
      importModel,
      ImportColis,
      SubstrPhone,
      checkPhone,
      GetId,
      SaveColis,
      RemoveRow,
      AllFragile,
      AllOpen,
      getReplace,
      load_add,
      progress,
      GetIdRef,
    };
  },
});
</script>

<style scoped>
/* Remove heavy borders from inputs inside the table */
.table .form-control, .table .form-select {
    border: 1px solid #e9ecef;
    font-size: 0.85rem;
    padding: 0.35rem 0.5rem;
}

.table .form-control:focus, .table .form-select:focus {
    border-color: #3f51b5;
    box-shadow: none;
}

/* Make table headers look lighter */
.table-header th {
    background-color: #f8f9fa;
    text-transform: uppercase;
    font-size: 0.75rem;
    letter-spacing: 0.5px;
    font-weight: 600;
    vertical-align: middle;
}

/* Hover pointer for switches */
.hover-pointer {
    cursor: pointer;
}

/* Better spacing for the responsive table */
.table-responsive {
    overflow-x: auto;
    scrollbar-width: thin;
}
</style>
